import { setter } from './utils';
import { SET_PAGE } from '../actions/types';

export default setter(SET_PAGE, 0);
